import { Screen } from '~/screens/users';

export const UsersIndex: React.FC = () => <Screen />;
